import * as React from "react";

const ChevronRight = ({ size = 14, fill = "#722ED1" }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4.87398 3.68416C4.59759 3.92864 4.59759 4.32358 4.87398 4.56807L7.62366 7.0004L4.87398 9.43272C4.59759 9.67721 4.59759 10.0721 4.87398 10.3166C5.15036 10.5611 5.59683 10.5611 5.87322 10.3166L9.12606 7.43922C9.40245 7.19473 9.40245 6.79979 9.12606 6.5553L5.87322 3.67789C5.60392 3.43967 5.15036 3.43967 4.87398 3.68416Z"
			fill={fill}
		/>
	</svg>
);
export default ChevronRight;
